import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  BOOKING_EP,
  BUNDLES_EP,
  GAPGRAPH_EP,
  PAYMENT_EP,
  PROPOSALS_EP,
  RATES_EP
} from '@app/shared/constants/globalConstants';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class InterestRateInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let clonedRequest = req;

    // This applies for endpoints that have `/rates` or `/proposals` or `/bundles` or `/gapgraph` in them
    if (req.body && typeof req.body === 'object') {
      if (
        (req.url.toLowerCase().includes(RATES_EP) ||
          req.url.toLowerCase().includes(PROPOSALS_EP) ||
          req.url.toLowerCase().includes(BUNDLES_EP) ||
          req.url.toLowerCase().includes(GAPGRAPH_EP)) &&
        'loanData' in req.body &&
        'interestRate' in req.body.loanData
      ) {
        const modifiedBody = {
          ...req.body,
          loanData: {
            ...req.body.loanData,
            interestRate: Number((req.body.loanData.interestRate / 100).toFixed(6))
          }
        };
        clonedRequest = req.clone({ body: modifiedBody });
      } else if (
        'interestRate' in req.body &&
        req.url.toLowerCase().includes(PAYMENT_EP)
      ) {
        const modifiedBody = {
          ...req.body,
          interestRate: Number((req.body.interestRate / 100).toFixed(6))
        };
        clonedRequest = req.clone({ body: modifiedBody });
      }
    }

    return next.handle(clonedRequest).pipe(
      map((event: HttpEvent<any>) => {
        // This applies only for response of `/proposals` and `/bookings`
        if (
          event instanceof HttpResponse &&
          (event.url?.toLowerCase().includes(PROPOSALS_EP) ||
            event.url?.toLowerCase().includes(BOOKING_EP)) &&
          event.body &&
          typeof event.body === 'object' &&
          'loanData' in event.body
        ) {
          const modifiedBody = {
            ...event.body,
            loanData: {
              ...event.body.loanData,
              interestRate: Number(
                (event.body.loanData.interestRate * 100).toFixed(6)
              )
            }
          };
          return event.clone({ body: modifiedBody });
        }
        return event;
      })
    );
  }
}
